import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { Form, FormGroup, Label, Button, Input, Table, FormFeedback } from 'reactstrap';
import moment from 'moment';


export class TermsControlBB extends Component {
    static displayName = TermsControlBB.name;
    //This is a page for managing when a Blackboard job runs and for what terms it should be running for, so we don't have to go into the Jobs in SSMS to change these manually
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            returnable: [],
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            jobTableData: [",","."],
            jobOptions: [",", "."],
            termOptions: [",", "."],
            badInput: false,
            showTable: false
        }
        this.getData();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
            loading: false,
            username: data.username,
        });
        this.setState({
            level: this.props.ourLevel
        });
        var dept = this.state.returnable.level
        this.recordComingHere();
        this.testPermission();
    }

    async recordComingHere() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            pagePK: "1032",
            department: this.state.returnable.level,
            userPCID: this.state.returnable.pcid,
            ip: this.state.ip,
            browser: this.state.browser,
            userID: this.state.returnable.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    async testPermission() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pagepk: "1032"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.getJobOptions();
        this.getTermOptions();
        this.getJobTerms();
    }

    async getJobTerms() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetBBJobTerms', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            jobTableData: data,
            showTable: true
        })
    }

    async getTermOptions() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetBBTerms', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            termOptions: data
        })
    }

    async getJobOptions() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetBBJobs', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            jobOptions: data
        })
    }

    componentDidMount() {

    }

    async addJobTerm(e) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        e.preventDefault();
        const dataInput = new FormData(e.target);
        if (dataInput.get('jobname') == null
            || dataInput.get('jobname') == "DEFAULT"
            || dataInput.get('term') == null
            || dataInput.get('term') == "DEFAULT"//covering all my bases here
            || dataInput.get('startdate') == null
            || dataInput.get('startdate') == '') {
            this.setState({
                badInput: true
            })//We'll leave a bad input message up until the user corrects it
            return;
        }
        else {
            this.setState({
                badInput: false
            })
            let toSend = {
                userLevel: this.state.returnable.level,
                jobPK: dataInput.get('jobname'),
                termSPID: dataInput.get('term'),
                startDate: dataInput.get('startdate'),
                endDate: dataInput.get('enddate')
            }
            const response = await fetch('AddNewBBTerm', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            })
            const data = await response.json();
            localStorage.setItem("lastFetch", moment());
            this.getJobTerms();
        }
    }

    findValidDefaultDate(str) {//Date input types in reactstrap require a specific format of date in order for it to accept it as a default. Unfortunately, every technology this
                                //information passes through has different ideas about how a date should be displayed, and none of them are reactstrap's version. I've gotten around this
                                //by handling date as a string of numbers in yyyymmdd pattern, and it comes into React as is since it's not a date but a string. Here, I take that string
                                //and add the dashes it needs in order to become a date in the valid default format.
                                //I could've done this in the controller, but doing it at the closest layer works out better in terms of making sure it's right when it hits the pavement
        let finalString = str.substring(0, 4) + "-" + str.substring(4, 6) + "-" + str.substring(6)
        return finalString;
    }

    async changeEndDate(e, pk) {
        e.preventDefault();
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: this.state.returnable.level,
            pk: pk,
            newend: e.target.value
        }
        const response = await fetch('UpdateEndDateBB', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.getJobTerms();
    }

    showTable() {
        return (
            <Table striped hover>
                <thead>
                    <tr>
                        <th>PK</th>
                        <th>Job Name</th>
                        <th>Term</th>
                        <th>Frequency</th>
                        <th>Description</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.jobTableData.map(pair => (
                        <tr>
                            <td>{pair.pk}</td>
                            <td>{pair.name}</td>
                            <td>{pair.term}</td>
                            <td>{pair.frequency}</td>
                            <td>{pair.description}</td>
                            <td>{this.findValidDefaultDate(pair.startdate)}</td>
                            <td><Input type="date" defaultValue={this.findValidDefaultDate(pair.enddate)} name="newdate" id="newdate" onChange={(e) => this.changeEndDate(e, pair.pk)} /></td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            )
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch == true) {
            this.props.passNewPage(1);
        }
        let showTable = <div></div>
        if (this.state.showTable == true) showTable = this.showTable();
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Form className="d-flex" inline onSubmit={this.addJobTerm.bind(this)}>
                                <FormGroup>
                                    <Label>Job Name</Label>
                                    <Input type="select" name="jobname" id="jobname" defaultValue="DEFAULT"
                                        invalid={this.state.badInput == true ? true : false}   >{/*We only need to put the invalid prop on the first one since the error message is pretty long*/ }
                                        <option disabled value="DEFAULT">Select Job...</option>
                                        {this.state.jobOptions.map(job => (
                                            <option value={job.pk}>{job.name}</option>
                                            ))}
                                    </Input>
                                    <FormFeedback invalid>Job Name, Term, and Start Date must be selected. End Date may be left blank.</FormFeedback>
                                </FormGroup>
                                &nbsp;
                                <FormGroup>
                                    <Label>Term</Label>
                                    <Input type="select" name="term" id="term" defaultValue="DEFAULT" >
                                        <option disabled value="DEFAULT">Select Term...</option>
                                        {this.state.termOptions.map(term => (
                                            <option value={term.sortorder}>{term.yearterm}</option>
                                            ))}
                                    </Input>
                                </FormGroup>
                                &nbsp;
                                <FormGroup>
                                    <Label>Start Date</Label>
                                    <Input type="date" name="startdate" id="startdate" />
                                </FormGroup>
                                &nbsp;
                                <FormGroup>
                                    <Label>End Date</Label>
                                    <Input type="date" name="enddate" id="enddate" />
                                </FormGroup>
                                &nbsp;
                                <Button type="submit" outline color="success" >Add</Button>
                            </Form>
                            <br />
                            {showTable}
                        </div>
                    )}
                </UserContext.Consumer>
            );
        
    }
}